import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { Dashboard } from 'src/generated-api-client';
import { DashboardListItem } from 'src/pages/MetabasePage/DashboardListItem';
import { MetabasePagePresentation } from 'src/pages/MetabasePage/MetabasePagePresentation';
import { MetabaseStore } from 'src/stores/MetabaseStore/MetabaseStore';
import styled from 'styled-components';

const store = MetabaseStore;

export const MetabasePage = observer(() => {
    return (
        <StyledMasterDetailsPage
            pageName="dashboards"
            store={store}
            asidePanel={store.list?.length > 1 ? <MetabasePanel /> : undefined}
            data-testid="dashboards-page"
        >
            <MetabasePagePresentation
                store={store}
                entityName="dashboard-entity-presentation"
            />
        </StyledMasterDetailsPage>
    );
});

const MetabasePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(item: Dashboard) => {
                return (
                    <List.Item
                        key={item.id}
                        data-testid={`master-details-list-item-${item.id}`}
                    >
                        <DashboardListItem item={item} />
                    </List.Item>
                );
            }}
        />
    );
});

const StyledMasterDetailsPage = styled(MasterDetailsPage)`
    main {
        padding: 2rem 0;
        height: 100%;
    }
`;
